import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { TabSettingsWorkspaceWrapper } from '../_base/TabSettingsWorkspaceWrapper';
import { ESettingsWorkspaceTab } from '../ESettingsWorkspaceTab';
import { WSTableAllTimeCredits } from './table_all_time/WSTableAllTimeCredits';
import { WSTableCreditsStatistics } from './table_credits_statistics/WSTableCreditsStatistics';

export const TabSettingsWorkspaceCreditsStatistics = () => {
  return (
    <TabSettingsWorkspaceWrapper type={ESettingsWorkspaceTab.CREDITS_STATISTICS} required_owner_access>
      <div
        className="flex flex-col justify-start items-start mt-2 gap-3  text-page-foreground overflow-auto"
        style={{ height: `calc(100vh - ${CONSTANTS__client.TOPBAR_HEIGHT}px` }}
      >
        <WSTableAllTimeCredits />

        <WSTableCreditsStatistics />
      </div>
    </TabSettingsWorkspaceWrapper>
  );
};
